import React from 'react';
import { m } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { SectionTag } from '../ui/SectionTag';
import { pillars } from '../../data/whatYouGet';
export function WhatYouGet() {
  return <section className="bg-bg-secondary py-14 sm:py-16" data-id="element-247" data-mp="143gjy1emab8g">
      <div className="mx-auto max-w-3xl px-6 text-center sm:px-8" data-id="element-248" data-mp="100tqxx67mk9o">
        <SectionTag icon="🎁" data-id="element-249" data-mp="zzinxzkl9gjm">Lo que recibes hoy (Acceso Inmediato)</SectionTag>
        <h2 className="mt-5 font-heading text-[28px] font-bold uppercase text-marino sm:text-[36px]" data-id="element-250" data-mp="1dza5ube87h2w">
          Todo lo que necesitas, en un solo lugar.
        </h2>
        <p className="mt-4 text-base leading-relaxed text-gris-texto sm:text-lg" data-id="element-251" data-mp="1nqwfw4etva42">
          Sesiones listas para que preparar el entrenamiento deje de comerse tu tiempo.
        </p>
        <p className="mt-2 text-sm font-semibold text-naranja" data-id="element-252" data-mp="1wr2rfkqyu00l">
          Sesiones listas · 6 Tomos · +10 Meses de entrenamiento · 100% Digital
        </p>
      </div>

      <div className="mx-auto mt-10 grid max-w-5xl gap-6 px-6 sm:px-8 lg:grid-cols-2" data-id="element-253" data-mp="1rtt1m3znzmc8">
        {pillars.map((pillar, i) => <m.div key={pillar.title} initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.45,
        delay: i % 2 * 0.1
      }} className="flex flex-col rounded-2xl border-2 border-naranja bg-white p-6 shadow-leve sm:p-7" data-id="element-254" data-mp="2zxoudbbnu9lz" data-mpi={i}>
            <div className="flex items-start justify-between gap-3" data-id="element-255" data-mp="3dwwt633wvfpn">
              <div className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-xl bg-azul-light" data-id="element-256" data-mp="3ivrepct9jidg">
                <pillar.icon size={22} className="text-azul" data-id="element-257" data-mp="3nokerndse2j7" />
              </div>
              <span className="rounded-full bg-verde-light px-3 py-1 text-xs font-semibold text-verde" data-id="element-258" data-mp="3smlzsdurwbxb">
                {pillar.tag}
              </span>
            </div>
            <h3 className="mt-4 font-heading text-lg font-bold leading-snug text-marino sm:text-xl" data-id="element-259" data-mp="5hmnkl0tbsd4">
              {pillar.title}
            </h3>
            <div className="mt-2 flex items-baseline gap-2 text-sm" data-id="element-260" data-mp="22j28umbgzzw7">
              <span className="text-rojo line-through" data-id="element-261" data-mp="1xjpivspaycpe">Valor: {pillar.value}</span>
              <span className="font-semibold text-verde" data-id="element-262" data-mp="2bac9exkwswae">{pillar.today}</span>
            </div>
            <p className="mt-3 text-sm leading-relaxed text-gris-texto" data-id="element-263" data-mp="26jvsh3hvqsja">{pillar.lead}</p>
            <ul className="mt-4 space-y-2.5" data-id="element-264" data-mp="26i1c82hjzolj">
              {pillar.items.map(item => <li key={item} className="flex items-start gap-2.5 text-sm leading-relaxed text-gris-texto" data-id="element-265" data-mp="2lal8qka76xu0">
                  <CheckIcon size={16} className="mt-0.5 flex-shrink-0 text-verde" data-id="element-266" data-mp="2u9gejv9by5ws" />
                  <span data-id="element-267" data-mp="2u7candbfl6wi">{item}</span>
                </li>)}
            </ul>
          </m.div>)}
      </div>
    </section>;
}